import Backbone from 'backbone';

var PendingVivokidChallengeRequests = Backbone.Collection.extend({
    url: function() {
        return '/vivokidchallenge-service/adHocChallenge/invite';
    },

    backend: 'gcapi'
});

export default PendingVivokidChallengeRequests;
